module.exports = __webpack_public_path__ + "img/1.9b006fcf.jpg";